var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('aside')}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54ef2ebe","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./ixcms/themes/gqf/src/vue-src/base/_base-product-sidebar-wrapper.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-54ef2ebe","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./ixcms/themes/gqf/src/vue-src/base/_base-product-sidebar-wrapper.vue
// module chunks = 24